document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('.bmkabr-faq');

  containers.forEach(function (container) {
    var items = container.querySelectorAll('.bmkabr-faq-item');

    items.forEach(function (item) {
      var btn = item.querySelector('.bmkabr-faq-q');
      var panel = item.querySelector('.bmkabr-faq-a');
      var inner = item.querySelector('.bmkabr-faq-a-inner');

      if (!btn || !panel || !inner) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('bmkabr-open');

        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('bmkabr-open');
            var otherBtn = other.querySelector('.bmkabr-faq-q');
            var otherPanel = other.querySelector('.bmkabr-faq-a');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.style.maxHeight = null;
          }
        });

        if (isOpen) {
          item.classList.remove('bmkabr-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = null;
        } else {
          item.classList.add('bmkabr-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = (inner.offsetHeight + 32) + 'px';
        }
      });
    });
  });
});